import { useState, useCallback } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { DocumentUpload } from "@/components/documents/DocumentUpload";
import { DocumentHistory } from "@/components/documents/DocumentHistory";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTenant } from "@/hooks/useTenant";
import { PROD_TENANT_SLUG } from "@/lib/constants";

export default function Documents() {
  const [showUpload, setShowUpload] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { activeTenant } = useTenant();
  /* BETA_LOCKDOWN */
  const isProdLocked = activeTenant === PROD_TENANT_SLUG;

  const handleUploadComplete = useCallback(() => {
    setRefreshKey((k) => k + 1);
    setShowUpload(false);
  }, []);

  return (
    <AppLayout
      title="Documents"
      actions={
        /* BETA_LOCKDOWN */
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <Button size="sm" onClick={() => setShowUpload(true)} disabled={isProdLocked}>
                  <Upload className="h-4 w-4 mr-2" />
                  Upload
                </Button>
              </span>
            </TooltipTrigger>
            {isProdLocked && <TooltipContent>Disabled in Beta</TooltipContent>}
          </Tooltip>
        </TooltipProvider>
      }
    >
      <DocumentHistory key={refreshKey} />

      <Dialog open={showUpload} onOpenChange={setShowUpload}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Upload Document</DialogTitle>
          </DialogHeader>
          <DocumentUpload onComplete={handleUploadComplete} />
        </DialogContent>
      </Dialog>
    </AppLayout>
  );
}